import { makeStyles } from 'makeStyles';
import { TEXT_GREEN } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  titleTypography: {
    fontSize: 20,
  },
  groupNameWrapper: {
    marginTop: 20,
    marginBottom: 8,
  },
  actionsTypography: {
    fontWeight: 500,
  },
  actionsSelectedTypography: {
    color: TEXT_GREEN,
  },
  actionsWrapper: {
    marginTop: 20,
  },
  deselectAllTypography: {
    color: theme.palette.primary.main,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  viewGroupsTitleContainer: {
    marginBottom: 20,
  },
  viewGroupsDialogTitle: {
    fontSize: 20,
    fontWeight: 600,
  },
}));
